<template>
  <div class="fclca-form-item">
    <label :for="form_item.model" :class="{ 'two-line': twoLine }">
      {{ form_item.name }}
      <span v-if="form_item.required"> * </span>
    </label>
    <input
      :id="form_item.model"
      :type="form_item.type"
      :required="form_item.required"
      v-model="currentValue"
      maxlength="255"
      :min="form_item.model=='expiration_at'?minData:''"
      :max="form_item.model=='issued_at'?maxData:''"
      :placeholder="form_item.placeholder || form_item.name"
    />
  </div>
</template>
<script>
export default {
  props: ["form_item", "twoLine", "value",'minData','maxData'],
  data() {
    return {
      currentValue: "",
    };
  },
  watch: {
    value: {
      handler(newV) {
        this.currentValue = newV;
      },
      immediate: true,
    },
    currentValue: {
      handler(newV) {
        this.$emit("input", newV);
        this.$emit("change", newV);
      },
    },
  },
};
</script>
<style scoped lang='scss'>
.fclca-form-item {
  display: flex;
  flex-wrap: wrap;
  label {
    font-size: 16px;
    font-family: Roboto;
    font-weight: 400;
    color: #3a3a3a;
    line-height: 18px;
    margin-bottom: 14px;
    @media screen and(max-width: 768px) {
      margin-bottom: 12px;
    }
    span {
      color: red;
    }
  }
  @media screen and (max-width: 768px) {
    .two-line {
      line-height: 18px;
      height: 36px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  input {
    min-width: 95%;
    width: 100%;
    border-radius: 5px;
    border: 1px solid #d9d9d9;
    background-color: #f5f5f7 ;
    padding: 16px 14px;
    font-size: 14px;
    color: #999999;
  }
  label,
  input {
    width: 100%;
  }
}
</style>